<div class="container" >
  <section class="my-4">
    <div class="scrollmenu">
      <a   [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
      <a  [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
      <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a> 

      <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
       <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
      <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a> 
      <a  [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a>
      <!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a>
      <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a> -->
    </div>
  </section>
  <section class="mt-3">
    <div class="container">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="float-right">

            <button class="dash-btns btn mr-3" [routerLink]="['/PayOut/ManagePayOutContact']">Manage Payout  Contact</button>

            <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>


          </div>
        </div>
        <div class="col-md-6" *ngIf="Addbeneficiarie">
          <div class="card-1">
            
            <h4 class="gary-t pt-35 font-20 mb-0">Add PayOut Beneficiary</h4>
            <div class="pt-35">
              <div class="row ">
                <div class="col-md-12">
                  <form>
                    <div class="form-group p-2">

                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Bank Code/IFSC Code*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="Bank Code/IFSC Code"
                              id="BankCode" name="BankCode" [formControl]="BankCode" maxlength="11" minlength="9" (change)=CheckAccNumAndIfsccode() (blur)=GetIfsccodedetails()>
                            </div>
                        

                        </div>
                      </div>
                      <div  class="text-right col-12 mt-3">  
                        <button class="btn dash-btns" id="Savecoupon" color="primary"
                        (click)="GetIfsccodedetails()" [disabled]="BankCode.invalid">
                        GetIFSCcodedetails</button>
                      </div>
                      <!-- <div class="row pt-2">

                                <div class="col-lg-4 col-md-5">
                                    <label class="customlabel">BankCode Type*</label>
                                </div>
                                  
                                  <div class="col-lg-12">
                                    <div class="form-group formgroup-tm">
                                    <ngx-select [items]="Type" id="BankCodeType" placeholder="BankCode Type" name="BankCodeType" [formControl]="BankCodeType"  required></ngx-select>
                                    </div>
                                    <span class="text-danger" *ngIf="BankCodeType.invalid && (BankCodeType.dirty || BankCodeType.touched)">{{BankCodeTypeerrors()}}</span>
                                </div>
                            </div> -->
                            
                      <!-- <div class="row pt-2">
                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Bank Name*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="BankName"
                              id="BankName" name="BankName" [formControl]="BankName" [(ngModel)]="IfscBankName">
                          </div>
                          
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Branch Name*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="BranchName"
                              id="BranchName" name="BranchName" [formControl]="BranchName" [(ngModel)]="IfscBranchName">
                          </div>
                        
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Address</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="Address"
                              id="Address" name="Address" [formControl]="Address" [(ngModel)]="IfscAddress">
                          </div>
                         
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">ZipCode</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="ZipCode"
                              id="ZipCode" name="ZipCode" [formControl]="ZipCode" [(ngModel)]="IfscZipCode" maxlength="6" (change)="Getzipcodedetails()">
                          </div>
                          
                        </div>
                      </div>
                    
                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">City</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="City"
                              id="City" name="City" [formControl]="City" [(ngModel)]="IfscCity">
                          </div>
                          
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">State</label>
                             <ngx-select [items]="stateList" class="formcontrol-user1" type="text" placeholder="State"
                              id="State" name="State" [formControl]="State" [(ngModel)]="IfscState">
                              </ngx-select> 
                              <div class="selectcustom mb-0">
                                <ngx-select [items]="stateList"  type="text" placeholder="State"
                                id="State" name="State" [formControl]="State" [(ngModel)]="IfscState">
                                </ngx-select>
                              </div>
                             
                          </div>
                         
                        </div>
                      </div> -->
                      <div class="" *ngIf="ifsccodedetails">
                       <div class="row pt-2">
                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Bank Name*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="BankName"
                              id="BankName" name="BankName" [formControl]="BankName" [(ngModel)]="IfscBankName">
                          </div>
                          
                        </div>
                      </div> 
                       <div class="row pt-2">
                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Branch Name*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="BranchName"
                              id="BranchName" name="BranchName" [formControl]="BranchName" [(ngModel)]="IfscBranchName">
                          </div>
                        
                        </div>
                      </div> 
                      </div>
                      <div class="" *ngIf="ifsccodedetailsshow">
                        <div class="row pt-2">
                         <div class="col-lg-12">
                          
                           <div class="form-group formgroup-tm">
                             <label class="customlabel">Bank Name*</label>
                             <input class="formcontrol-user1 form-control" type="text" placeholder="BankName"
                               id="BankName" name="BankName" [formControl]="BankName" [(ngModel)]="IfscBankName">
                           </div>
                           
                         </div>
                       </div>
                        <div class="row pt-2">
                         <div class="col-lg-12">
                          
                           <div class="form-group formgroup-tm">
                             <label class="customlabel">Branch Name*</label>
                             <input class="formcontrol-user1 form-control" type="text" placeholder="BranchName"
                               id="BranchName" name="BranchName" [formControl]="BranchName" [(ngModel)]="IfscBranchName"readonly>
                           </div>
                         
                         </div>
                       </div> 
                       </div>
                      
                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Beneficiary Name*</label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="Beneficiary Name" 
                              id="BeneficiaryName" name="BeneficiaryName" [formControl]="BeneficiaryName" >
                          </div>
                         
                        </div>
                      
                      </div>
                      <div class="row pt-2">

                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Account Number*</label>
                            <input class="formcontrol-user1 form-control" type="password" placeholder="AccountNumber"
                              id="AccountNumber" name="AccountNumber" [formControl]="AccountNumber" maxlength="18" (keypress)="numberOnly($event)"
                              minlength="9" (blur)="checkaccnumber()" (change)=CheckAccNumAndIfsccode()>
                          </div>
                          </div>
                      </div>


                      <div class="row pt-2">
                        <div class="col-lg-12">
                          
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Confirm Account Number*</label>
                            <input class="formcontrol-user1 form-control" onpaste="return false" type="text"
                              placeholder="Confirm Account Number" id="ConfirmAccountNumber" name="ConfirmAccountNumber"
                              [formControl]="ConfirmAccountNumber" maxlength="18" minlength="9" (keypress)="numberOnly($event)"
                              (blur)="checkaccnumber()" onpaste="return false">
                          </div>
                          

                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-lg-12">
                          <div class="form-group formgroup-tm">
                            <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="BankAccountType" id="BankAccountType" name="BankAccountType" [formControl]="BankAccountType"> -->
                            <label class="customlabel">BankAccount Type*</label>
                            <div class="selectcustom mb-0">
                              <ngx-select [items]="AccountType" id="BankAccountType" placeholder="BankAccount Type"
                              name="BankAccountType" [formControl]="BankAccountType" required></ngx-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="row pt-2">

                      <div class="col-lg-4 col-md-5">
                          <label class="customlabel">BankCountry<span
                                  class="text-danger"></span></label>
                      </div>
                        
                        <div class="col-lg-12">
                          <div class="form-group formgroup-tm">
                            <ngx-select [items]="CountryList" placeholder="BankCountry" id="BankCountry" name="BankCountry" [formControl]="BankCountry">
                            </ngx-select>
                         
                          </div>
                         
                      </div>
                  </div> -->

                      <!-- <div class="row pt-2">

                    <div class="col-lg-4 col-md-5">
                        <label class="customlabel">VerificationStatus<span
                                class="text-danger"></span></label>
                    </div>
                      
                      <div class="col-lg-12">
                        <div class="form-group formgroup-tm">
                        <input class="formcontrol-user1 form-control" type="text" placeholder="VerificationStatus" id="VerificationStatus" name="VerificationStatus" [formControl]="VerificationStatus">
                        </div>
                        <span class="text-danger" *ngIf="VerificationStatus.invalid && (VerificationStatus.dirty || VerificationStatus.touched)">{{VerificationStatuserrors()}}</span>
                    </div>
                </div> -->

                      <!-- <div class="row pt-2">

                  <div class="col-lg-4 col-md-5">
                      <label class="customlabel">VerificationResponse<span
                              class="text-danger"></span></label>
                  </div>
                    
                    <div class="col-lg-12">
                      <div class="form-group formgroup-tm">
                      <input class="formcontrol-user1 form-control" type="text" placeholder="VerificationResponse" id="VerificationResponse" name="VerificationResponse" [formControl]="VerificationResponse">
                      </div>
                                         </div>
              </div> -->

                      <div class="row pt-2">



                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">Preferred PayOut Account </label>
                            <div class="selectcustom mb-0">
                              <ngx-select [items]="PayOutAccountList" placeholder="PreferredPayOutAccount"
                              id="PreferPayOutAccount" name="PreferPayOutAccount" [formControl]="PreferPayOutAccount"
                              (blur)="AccountTypeChange()">
                            </ngx-select>
                            </div>
                          </div>
                        </div>
                      </div>




                      <div class="row pt-2" *ngIf="upitxt">


                        <div class="col-lg-12">
                         
                          <div class="form-group formgroup-tm">
                            <label class="customlabel">UpiVpa </label>
                            <input class="formcontrol-user1 form-control" type="text" placeholder="UpiVpa" id="UpiVpa"
                              name="UpiVpa" [formControl]="UpiVpa">
                          </div>
                          <!-- <span class="text-danger" *ngIf="PayoutCustomerkeyId.invalid && (PayoutCustomerkeyId.dirty || PayoutCustomerkeyId.touched)">{{PayoutCustomerkeyIderrors()}}</span> -->
                        </div>
                      </div>








                      <div class="text-left pt-3">

                        <button class="btn dash-btns" id="Savecoupon" color="primary"
                          [disabled]="BankCode.invalid  || AccountNumber.invalid ||BeneficiaryName.invalid||accerrormessage||ConfirmAccountNumber.invalid||Bankdetailserrormessage||BankName.invalid||BranchName.invalid||BankAccountType.invalid "
                          (click)="NewBeneficiarie()">Proceed Now</button>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="Editbeneficiarie">
          <div class="card-1">
             
            <h4 class="gary-t pt-35 font-20 mb-0">Add PayOut Beneficiary</h4>
            <div class="pt-35">
              <div class="row ">

                <div class="col-md-12" *ngIf="Editbeneficiarie">
                  <div>
                    <form>
                      <div class="f  p-2">

                        <div class="row pt-2">

                          <div class="col-lg-6">
                            <label class="gary-t  l-h21 font-14 mb-3">PayOut Beneficiary KeyId*</label>
                          </div>

                          <div class="col-lg-6">
                            <!-- <div class="form-group formgroup-tm"> -->
                            {{rows.PayOutBeneficiaryKeyId}}
                            <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="PayOut Beneficiary KeyId" id="PayOutBeneficiaryKeyId" name="PayOutBeneficiaryKeyId" [formControl]="BenPayOutBeneficiaryKeyId"  [(ngModel)]="rows.PayOutBeneficiaryKeyId" readonly> -->
                            <!-- </div> -->
                            <!-- <span class="text-danger" *ngIf="PayOutBeneficiaryKeyId.invalid && (PayOutBeneficiaryKeyId.dirty || PayOutBeneficiaryKeyId.touched)">{{PayOutBeneficiaryKeyIderrors()}}</span> -->
                          </div>
                        </div>
                        <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Bank Code/IFSC Code*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Bank Code/IFSC Code"
                                id="BenBankCode" name="BenBankCode" [(ngModel)]="rows.BankCode"
                                [formControl]="BenBankCode"  (blur)="GetUpdateIfsccodedetails()" maxlength="11" minlength="9" (change)="EditCheckAccNumAndIfsccode()">
                            </div>
                            
                          </div>
                        </div>

                        <div  class="text-right col-12 mt-3">  
                          <button class="btn dash-btns" id="Savecoupon" color="primary"
                          (click)="GetUpdateIfsccodedetails()" [disabled]="BenBankCode.invalid">
                          GetIFSCcodedetails</button>
                        </div>
                        <div class="row pt-2">

                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Beneficiary Name*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="BeneficiaryName"
                                id="BeneficiaryName" name="BeneficiaryName" [(ngModel)]="rows.BeneficiaryName"
                                [formControl]="BenBeneficiaryName" (keydown)="onKey()">
                              <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="Beneficiary Name" id="BeneficiaryName" name="BeneficiaryName"     [formControl]="BeneficiaryName"> -->
                            </div>
                           
                          </div>
                        </div>
                        <!-- <div class="row pt-2">
  
                                    <div class="col-lg-4 col-md-5">
                                        <label class="customlabel">BankCode Type<span
                                                class="text-danger">*</span></label>
                                    </div>
                                      
                                      <div class="col-lg-12">
                                        <div class="form-group formgroup-tm">
                                       
                                        <ngx-select [items]="Type" id="BankCodeType" placeholder="BankCode Type" name="BankCodeType"  [formControl]="BenBankCodeType"  [(ngModel)]="rows.BankCodeType" required (select)="onKey()" ></ngx-select>
                                        </div>
                                        <span class="text-danger" *ngIf="BenBankCodeType.invalid && (BenBankCodeType.dirty || BenBankCodeType.touched)">{{BankCodeTypeerrors()}}</span>
                                    </div>
                                </div> -->
                                <div class="" *ngIf="updateifsccodedetailsshow">

                         <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">BankName*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="BankName"
                                id="BankName" name="BankName" [(ngModel)]="rows.BankName" [formControl]="BenBankName"
                                (keydown)="onKey()" readonly>
                            </div>
                            
                          </div>
                        </div>
                        <div class="row pt-2">

                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">BranchName*</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="BranchName"
                                id="BranchName" name="BranchName" [(ngModel)]="rows.BranchName"
                                [formControl]="BenBranchName" (keydown)="onKey()" readonly>
                            </div>
                         
                          </div>
                        </div>
                        <!-- <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Address</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="Address"
                                id="Address" name="Address" [formControl]="BenAddress" [(ngModel)]="rows.Address" (keydown)="onKey()"readonly>
                            </div>
                         
                          </div>
                        </div> -->
                        <!-- <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">ZipCode</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="ZipCode"
                                id="ZipCode" name="ZipCode" [formControl]="ZipCode" [(ngModel)]="rows.ZipCode" (keydown)="onKey()" maxlength="6" (change)="GetEditzipcodedetails()"readonly>
                            </div>
                          </div>
                        </div>  -->

                         <!-- <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">City</label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="City"
                                id="City" name="City" [formControl]="City" [(ngModel)]="rows.City" (keydown)="onKey()"readonly>
                            </div>
                          </div>
                        </div>  -->
                         <!-- <div class="row pt-2">
                          <div class="col-lg-12">
                           
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">State</label>
                              <ngx-select  [items]="stateList"  type="text"  placeholder="State"
                              id="State" name="State" [formControl]="State" [(ngModel)]="rows.State" (select)="onKey()" >
                              </ngx-select>
                                <input class="formcontrol-user1 form-control" type="text" placeholder="State"
                                id="State" name="State" [formControl]="State" [(ngModel)]="rows.City" (keydown)="onKey()">  
                             </div> 
                            
                          </div>
                        </div> -->
                      </div>
  
                      <div class="" *ngIf="updateifsccodedetails">

                        <div class="row pt-2">
                         <div class="col-lg-12">
                           
                           <div class="form-group formgroup-tm">
                             <label class="customlabel">BankName*</label>
                             <input class="formcontrol-user1 form-control" type="text" placeholder="BankName"
                               id="BankName" name="BankName" [(ngModel)]="rows.BankName" [formControl]="BenBankName"
                               (keydown)="onKey()">
                           </div>
                           
                         </div>
                       </div>
                       <div class="row pt-2">

                         <div class="col-lg-12">
                           
                           <div class="form-group formgroup-tm">
                             <label class="customlabel">BranchName*</label>
                             <input class="formcontrol-user1 form-control" type="text" placeholder="BranchName"
                               id="BranchName" name="BranchName" [(ngModel)]="rows.BranchName"
                               [formControl]="BenBranchName" (keydown)="onKey()">
                           </div>
                        
                         </div>
                       </div>
                       
                     </div> 
  
                        <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Account Number*</label>
                              <input class="formcontrol-user1 form-control" type="password" placeholder="Account Number"
                                id="BenAccountNumber" name="BenAccountNumber" [(ngModel)]="rows.AccountNumber"
                                [formControl]="BenAccountNumber" (keydown)="onKey()" (blur)="checkaccnumbers()"  (keypress)="numberOnly($event)"
                                maxlength="17" minlength="9" (blur)=EditCheckAccNumAndIfsccode()>
                            </div>
                 
                            
                            </div>
                        </div>


                        <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">Confirm Account Number*</label>
                              <input class="formcontrol-user1 form-control" onpaste="return false" type="text"
                                placeholder="Confirm Account Number" id="editConfirmAccountNumber"
                                name="editConfirmAccountNumber" [(ngModel)]="AccountNo"
                                [formControl]="editConfirmAccountNumber" maxlength="17" minlength="9" (keypress)="numberOnly($event)"
                                (blur)="checkaccnumbers()" (blur)="checkaccnumbers()">
                            </div>
                            

                          </div>
                        </div>

                        <div class="row pt-2">
                          <div class="col-lg-12">
                        
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">BankAccountType*</label>
                              <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="BankAccountType" id="BankAccountType" name="BankAccountType" [formControl]="BankAccountType"> -->
                              <div class="selectcustom mb-0">
                                <ngx-select [items]="AccountType" id="BankAccountType" placeholder="BankAccount Type"
                                name="BankAccountType" [formControl]="BenBankAccountType"
                                [(ngModel)]="rows.BankAccountType" (select)="onKey()" required></ngx-select>
                              </div>
                              

                            </div>
                            
                          </div>
                        </div>
                        <!-- <div class="row pt-2">
  
                          <div class="col-lg-4 col-md-5">
                              <label class="customlabel">BankCountry<span
                                      class="text-danger">*</span></label>
                          </div>
                            
                            <div class="col-lg-12">
                              <div class="form-group formgroup-tm">
                             
                              <ngx-select [items]="CountryList" placeholder="BankCountry" id="BankCountry" name="BankCountry"  [(ngModel)]="rows.BankCountry" [formControl]="BenBankCountry" (keydown)="onKey()">
                              </ngx-select>
                            
                            </div>
                             
                          </div>
                      </div> -->
                        <!-- 
                      <div class="row pt-2">
  
                        <div class="col-lg-4 col-md-5">
                            <label class="customlabel">VerificationStatus<span
                                    class="text-danger"></span></label>
                        </div>
                          
                          <div class="col-lg-12">
                            <div class="form-group formgroup-tm">
                            <input class="formcontrol-user1 form-control" type="text" placeholder="VerificationStatus" id="VerificationStatus" name="VerificationStatus" [(ngModel)]="rows.VerificationStatus" [formControl]="BenVerificationStatus" (keydown)="onKey()">
                            </div>
                          
                        </div>
                    </div> -->

                        <!-- <div class="row pt-2">
  
                      <div class="col-lg-4 col-md-5">
                          <label class="customlabel">VerificationResponse<span
                                  class="text-danger"></span></label>
                      </div>
                        
                        <div class="col-lg-12">
                          <div class="form-group formgroup-tm">
                          <input class="formcontrol-user1 form-control" type="text" placeholder="VerificationResponse" id="VerificationResponse" name="VerificationResponse" [(ngModel)]="rows.VerificationResponse" [formControl]="BenVerificationResponse" (keydown)="onKey()">
                          </div>
                        
                      </div>
                  </div> -->




                        <div class="row pt-2">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">PreferredPayOutAccount </label>
                              <div class="selectcustom mb-0">
                                <ngx-select [items]="PayOutAccountList" placeholder="PreferredPayOutAccount"
                                id="PreferPayOutAccount" name="PreferPayOutAccount"
                                [(ngModel)]="rows.PreferPayOutAccount" [formControl]="BenPreferPayOutAccount"
                                (keydown)="onKey()" (blur)="EditAccountTypeChange()">
                              </ngx-select>
                              </div>
                             
                              <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="PreferPayOutAccount" id="PreferPayOutAccount" name="PreferPayOutAccount"  [(ngModel)]="rows.PreferPayOutAccount" [formControl]="BenPreferPayOutAccount" (keydown)="onKey()"> -->
                            </div>
                            <!-- <span class="text-danger" *ngIf="PreferPayOutAccount.invalid && (PreferPayOutAccount.dirty || PreferPayOutAccount.touched)">{{PreferPayOutAccounterrors()}}</span> -->
                          </div>
                        </div>

                        <!--                                 
              [disabled]="BankCodeType.invalid || PayOutBeneficiaryKeyId.invalid || BankName.invalid ||BranchName.invalid|| BankCode.invalid || BankCountry.invalid || AccountNumber.invalid || VerificationStatus.invalid || VerificationResponse.invalid"    -->


                        <div class="row pt-2" *ngIf="upitxt">
                          <div class="col-lg-12">
                            
                            <div class="form-group formgroup-tm">
                              <label class="customlabel">UpiVpa </label>
                              <input class="formcontrol-user1 form-control" type="text" placeholder="UpiVpa" id="UpiVpa"
                                name="UpiVpa" [formControl]="UpiVpa" [(ngModel)]="rows.UpiVpa" [formControl]="BenUpiVpa"
                                (keydown)="onKey()">
                            </div>
                            <!-- <span class="text-danger" *ngIf="PayoutCustomerkeyId.invalid && (PayoutCustomerkeyId.dirty || PayoutCustomerkeyId.touched)">{{PayoutCustomerkeyIderrors()}}</span> -->
                          </div>
                        </div>
                        <div class="text-left pt-3">

                          <button class="btn dash-btns" id="Savecoupon" color="primary"
                            [disabled]="!isReadytoUpdateInfo||BenBeneficiaryName.invalid||BenAccountNumber.invalid ||editConfirmAccountNumber.invalid||Editaccerrormessage||EditBankdetailserrormessage||BenBankName.invalid||BenBranchName.invalid||BenBankAccountType.invalid"
                            (click)="EditBeneficiarie()">Proceed Now</button>
                        </div>
                        <!-- [disabled]="BenBankCodeType.invalid ||  BenBankName.invalid ||BenBranchName.invalid|| BenBankCode.invalid || BenAccountNumber.invalid ||!isReadytoUpdateInfo||ConfirmAccountNumber.invalid||Editaccerrormessage" 
                                       -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div class="col-md-6" >
          <div class="card-1 p-2">
            <div class="text-center">
                <!-- <img src="assets/img/new/invoices.gif" /> -->
                <div *ngIf="!isimgHidden">
                  <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                </div>
            </div>
            <div class="" *ngIf="Addbeneficiarie">
              
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="BankCode.invalid && (BankCode.dirty || BankCode.touched)">{{BankCodeTypeerrors()}}</div>
              <div *ngIf="ifsccodedetail" class="text-danger">IFSC Details not found,Please enter Bank name and Branch Name.  </div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="BankName.invalid && (BankName.dirty || BankName.touched)">{{BankNameerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="BranchName.invalid && (BranchName.dirty || BranchName.touched)">{{BranchNameerrors()}}</div>
              <!-- <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="Address.invalid && (Address.dirty || Address.touched)">{{Addresserrors()}}</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="City.invalid && (City.dirty || City.touched)">{{Cityerrors()}}</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="State.invalid && (State.dirty || State.touched)">{{Stateerrors()}}</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{ZipCodeerrors()}}</div> --> 
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="BeneficiaryName.invalid && (BeneficiaryName.dirty || BeneficiaryName.touched)">{{BeneficiaryNameerrors()}}</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="AccountNumber.invalid && (AccountNumber.dirty || AccountNumber.touched)">{{Accountnumbererrors()}}</div>
                <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="Bankdetailserrormessage">Beneficiary already exists for this account number</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="ConfirmAccountNumber.invalid && (ConfirmAccountNumber.dirty || ConfirmAccountNumber.touched)">{{AccConfirmAccountnumbererrors()}}</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="accerrormessage">Account Number and Confirm Account Number
                should be same</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BankAccountType.invalid && (BankAccountType.dirty || BankAccountType.touched)">{{BankAccountTypeerrors()}}</div>
            </div>
            <div  *ngIf="Editbeneficiarie">

              <div *ngIf="updateifsccodedetail"    class="alert alert-danger py-2 mb-0 px-2 border-r border-0">IFSC Details not found,Please enter Bank name and Branch Name.
              </div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenBankCode.invalid && (BenBankCode.dirty || BenBankCode.touched)">{{BankCodeTypeerrorss()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenBeneficiaryName.invalid && (BenBeneficiaryName.dirty || BenBeneficiaryName.touched)">{{BenBeneficiaryNameerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenBankName.invalid && (BenBankName.dirty || BenBankName.touched)">{{BenBankNameerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenBranchName.invalid && (BenBranchName.dirty || BenBranchName.touched)">{{BranchNameerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenAddress.invalid && (BenAddress.dirty || BenAddress.touched)">{{Addresserrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="City.invalid && (City.dirty || City.touched)">{{Cityerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="State.invalid && (State.dirty || State.touched)">{{Stateerrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{ZipCodeerrors()}}</div>           
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="BenAccountNumber.invalid && (BenAccountNumber.dirty || BenAccountNumber.touched)">{{BenAccountnumbererrors()}}</div>
          
                 <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"
                *ngIf="EditBankdetailserrormessage">Beneficiary already exists for this account number</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
               *ngIf="editConfirmAccountNumber.invalid && (editConfirmAccountNumber.dirty || editConfirmAccountNumber.touched)">{{ConfirmAccountnumbererrors()}}</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="Editaccerrormessage">Account Number and Confirm Account
                Number should be same</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="BenBankAccountType.invalid && (BenBankAccountType.dirty || BenBankAccountType.touched)">{{BankAccountTypeerrors()}}</div>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </section>
</div>
 